import { observable, action } from "mobx";
import { Dictionary, entities } from "sbtech-sports-data-api-client";

/**
 * defines model for Selection
 * @typedef Selection
 * @type {Object}
 * @property {marketId} id of the market to which the selection belongs
 * @property {id} id of the selection itself
 * @property {outcomeType} value containing the outcome type of the selection
 * @property {type} id  of the type of the selection (ML, HC, OU)
 * @property {name} value of the name of the team or player in the selection
 * @property {displayOdds} collection containing the odd in all possible odd styles
 * @property {odds} value containing the odd for the given selection in the current selected odd style
 * @property {points} value containing the points in the event
 * @property {isDisabled} flag showing if this selection can be selected
 */

export type SelectionType = {
    marketId: string;
    id: string;
    sbTechId: string;
    outcomeType: string;  // corresponds to rowTypeId from the legacy
    type: string;  // corresponds to lineTypeId from the legacy
    name: string;
    displayName: string;
    displayOdds: Dictionary<string>
    odds: string;
    points: number;
    isDisabled: boolean;
    lineGroupId: string;
}

/* istanbul ignore next */

export class Selection {
    marketId: string;
    id: string;
    sbTechId: string; // this corresponds to lineId from the legacy. It is needed by the BetSlipUtil,
    outcomeType: string;
    type: string;
    name: string;
    @observable displayName: string;
    @observable displayOdds: Dictionary<string>;
    @observable odds: string;
    points: number;
    isDisabled: boolean;
    lineGroupId: string;

    constructor(selection: SelectionType) {
        this.marketId = selection.marketId;
        this.id = selection.id;
        this.sbTechId = selection.sbTechId;
        this.outcomeType = selection.outcomeType;
        this.name = selection.name;
        this.displayName = selection.displayName;
        this.type = selection.type;
        this.displayOdds = selection.displayOdds;
        this.odds = selection.odds;
        this.points = selection.points;
        this.isDisabled = selection.isDisabled;
        this.lineGroupId = selection.lineGroupId;
    }

    getSide()
    {
        // selection side isn't returned from the sports API
        // therefore, we try to get the side from the outcome
        switch (this.outcomeType) {
            case entities.OutcomeType.Over:
            case entities.OutcomeType.Home: {
                return entities.SelectionSide.Home as number;
            }
            case entities.OutcomeType.Draw:
            case entities.OutcomeType.Tie: {
                return entities.SelectionSide.Draw as number;
            }
            case entities.OutcomeType.Under:
            case entities.OutcomeType.Away: {
                return entities.SelectionSide.Away as number;
            }

            default:
                return 1; // for types that don't have outcome
         };
    }

    @action.bound
    setDisplayName(displayName: string)
    {
        this.displayName = displayName;
    }

    @action.bound
    setOddStyleChange(newOddsStyle: string) {
        this.odds = this.displayOdds[newOddsStyle];
    }

    @action.bound
    setOdds(odds: string, displayOdds: Dictionary<string>) {
        this.odds = odds;
        this.displayOdds = displayOdds;
    }
}